export const CORPORATE ='CORPORATE';
export const CORPORATESEARCH ='CORPORATESEARCH';